import React from "react";

/**
 * TrialEnd — shown after a trial request is submitted.
 *
 * Query-param behaviour:
 *   ?existing=true  → The requester already had an account. Their new company
 *                     was created (auto-approved) and linked to their existing
 *                     login. Instruct them to log in with their existing
 *                     credentials.
 *   (no param)      → Standard "pending review" message for new users whose
 *                     trial requires manual approval.
 */
const TrialEnd = (props: any) => {
    const search: string = props?.location?.search ?? "";
    const isExistingUser = new URLSearchParams(search).get("existing") === "true";

    if (isExistingUser) {
        return (
            <div>
                <h4>Sua empresa de trial foi criada com sucesso!</h4>
                <p>
                    Como você já possui uma conta na plataforma, basta{" "}
                    <a href="/">fazer login</a> com suas credenciais existentes
                    para acessar a nova empresa.
                </p>
            </div>
        );
    }

    return <h4>Obrigado pelo seu contato. Entraremos em contato em breve</h4>;
};

export default TrialEnd;
